// @flow
import React from "react";
import { Field } from "redux-form";
import { IconOptions } from "./IconOptions";
import { ConsumptionLevels, CompanyConsumptionLevels } from "Commons/Components/FormComponents/components/Consumption";
import { CategoryTypes } from "Commons/Modules/category";

type Props = { consumptionFieldName: string, isCompany: boolean, isCategoryStrom: boolean, onChange?: Function };

function Consumption({ consumptionFieldName, isCompany, isCategoryStrom, onChange }: Props) {
  const catType = isCategoryStrom ? CategoryTypes.ELECTRICITY : CategoryTypes.GAS;
  const consumptionValue = isCompany ? CompanyConsumptionLevels[catType] : ConsumptionLevels[catType];

  return (
    <Field
      name={consumptionFieldName}
      component={IconOptions}
      props={{
        options: [
          {
            icon: isCompany ? "industry1" : "person1",
            label: "",
            value: consumptionValue[0],
            dataCy: consumptionFieldName + "consumption",
          },
          {
            icon: isCompany ? "industry2" : "person2",
            label: "",
            value: consumptionValue[1],
          },
          {
            icon: isCompany ? "industry3" : "person3",
            label: "",
            value: consumptionValue[2],
          },
          {
            icon: isCompany ? "industry4" : "person4",
            label: "",
            value: consumptionValue[3],
          },
        ],
        onChange,
      }}
    />
  );
}

export default Consumption;
